import React from 'react'
import { Description, Head, Main, Row2, Sub } from './Ourteam.element'

function Heading() {
    return (
        <Main>
           <Sub>
               <Row2>
                   <Head>
                    OUR TEAM
                   </Head>
                   <Description>
                   Our team is empowered to build trust at every step. We work closely with Parents And Students to ensure all communications requirements are transparent and clearly addressed in a timely manner.
                   </Description>
               </Row2>
           </Sub>
        </Main>
    )
}

export default Heading